import React from "react";
import { useTranslation } from "react-i18next";
import SubjectScreeningHeaderFirstColumn from "./SubjectScreeningHeaderFirstColumn";
import SubjectScreeningHeaderSecondColumn from "./SubjectScreeningHeaderSecondColumn";
import MobileSubjectUserDetails from "./MobileSubjectUserDetails";

type Props = {};

const SubjectLastScreeningFilter = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div className="subject_details_container">
      <SubjectScreeningHeaderFirstColumn />
      <SubjectScreeningHeaderSecondColumn />
    </div>
  );
};

export default SubjectLastScreeningFilter;
